import { create } from "zustand";

type optionStore = {
  open: boolean;
  setOpen: (option: boolean) => void;
};

const optionStore = (set: any): optionStore => ({
  open: false,
  setOpen: (open) => set({ open }),
});

const useOptionStore = create(optionStore);

export default useOptionStore;
